import './AuthorAvatar.scss';
import React from 'react';
import PropTypes from 'prop-types';

import getFirstInitial from 'utils/getFirstInitial';
import connectStore from 'decorators/connectStore';

import ProfileImageStore from 'stores/ProfileImageStore';
import ProfileImageActionCreator from 'actions/media/ProfileImageActionCreator';

import ResizedMediaCentralImage from 'components/shared/ResizedMediaCentralImage';
import ProfileImageConstants from 'components/shared/media/ProfileImageConstants';
import ImageUploadStatus from 'components/shared/media/ProfileImageUploadStatus';

@connectStore(ProfileImageStore, 'profileImageState')
class AuthorAvatarContainer extends React.Component {
  render() {
    return (
      <AuthorAvatar {...this.props} />
    );
  }
}

class AuthorAvatar extends React.Component {
  static propTypes = {
    amazonAuthorId: PropTypes.string,
    authorName: PropTypes.string.isRequired,
    className: PropTypes.string,
    imageDiameter: PropTypes.number,
    profileImageExistsCallback: PropTypes.func,
    profileImageState: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.interval = null;
  }

  /* Attempt to fetch if there is no profile
  image for this account. If the image is
  processing, begin polling. */
  componentDidMount() {
    const profileImage = this.props.profileImageState.profileImages[this.props.amazonAuthorId];
    if (this.props.amazonAuthorId) {
      if (!profileImage) {
        ProfileImageActionCreator.fetch(this.props.amazonAuthorId);
      } else if (profileImage.status === ImageUploadStatus.PROCESSING) {
        this.startPollingProfileImage();
      } else {
        this.stopPollingProfileImage();
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.amazonAuthorId) {
      const { amazonAuthorId } = this.props;
      const nextImageState = nextProps.profileImageState;
      if (!nextImageState.err
          && nextImageState.profileImages[amazonAuthorId]
          && nextImageState.profileImages[amazonAuthorId].status !== ImageUploadStatus.PROCESSING) {
        this.stopPollingProfileImage();
        if (this.props.profileImageExistsCallback) {
          const imageExists = nextImageState.profileImages[amazonAuthorId].url !== undefined;
          this.props.profileImageExistsCallback(imageExists);
        }
      }
    }
  }

  componentWillUnmount() {
    this.stopPollingProfileImage();
  }

  getProfileImage() {
    const { amazonAuthorId } = this.props;
    const profileImage = this.props.profileImageState.profileImages[amazonAuthorId];

    return profileImage;
  }

  startPollingProfileImage() {
    const { amazonAuthorId } = this.props;
    this.interval = setInterval(() => {
      ProfileImageActionCreator.fetch(amazonAuthorId);
    }, ProfileImageConstants.POLLING_INTERVAL);
  }

  stopPollingProfileImage() {
    if (this.interval) {
      clearTimeout(this.interval);
    }
  }

  renderImage() {
    const profileImage = this.getProfileImage();
    const image = {
      src: profileImage.url,
      height: profileImage.metadata.height,
      width: profileImage.metadata.width,
    };

    const imageDiameter = this.props.imageDiameter || ProfileImageConstants.DIAMETER;
    const className = this.props.className ? `aa-avatar-container-${this.props.className}` : 'aa-avatar-container';
    return (
      <ResizedMediaCentralImage
        className={className}
        image={image}
        cropHeight={imageDiameter}
        cropWidth={imageDiameter}
        scaleHeight={imageDiameter}
        scaleWidth={imageDiameter}
      />
    );
  }

  renderPlaceholder() {
    const { authorName } = this.props;
    const title = authorName ? getFirstInitial(authorName) : '';
    const className = this.props.className ? `aa-avatar-container-${this.props.className}` : 'aa-avatar-container';
    return (
      <span className={className}>
        {title}
      </span>
    );
  }

  render() {
    const profileImage = this.getProfileImage();
    const url = profileImage ? profileImage.url : null;
    const imageAvailable = url && profileImage.status !== ImageUploadStatus.PROCESSING;

    return imageAvailable ? this.renderImage() : this.renderPlaceholder();
  }
}

export default AuthorAvatarContainer;
